import styled from 'styled-components'
import { Media } from '../theme'

export const Main = styled.main<{ $showTopBanner: boolean }>`
  padding-top: ${({ $showTopBanner }) => ($showTopBanner ? '48px' : '0')};
  ${Media.lessThan(Media.small)} {
    padding-top: unset;
  }
`
